module.exports = __webpack_public_path__ + "img/grid-blog-1.6d9fca96.png";